import { gql } from '@/__generated__/gql';

export const TODO_PAGE_ALLOCATION_TASKS_QUERY = gql(`
  query TodoPageAllocationTasks {
    AllocationTasks {
      newTaskCount
      oldTaskCount
      assignedToMeTaskCount
      ownedByMeNotAssignedToMeTaskCount
      investmentsSummary
    }
  }
`);

export const TODO_PAGE_ALLOCATION_TASKS_REDIRECT_QUERY = gql(`
  query TodoPageAllocationTasksRedirect {
    AllocationTasks {
      assignedToMeTaskCount
    }
  }
`);
